export function buy_contents(pid) {
  //pid = 인앱상품 고유id로서 스토어에 상품등록시 발급되는 id임. 전달해준 id로 호출되게 하면됨.
  let param = {
    action: 'buy_contents',
    productid: pid,
    callback: 'appInterFace'
  };
  console.log('buy_contents start');
  console.log(JSON.stringify(param));
  window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(param));
  console.log('buy_contents end');
}
//인앱결제 완료후 결과값 리턴함수
export function payment_result(val) {
  alert(JSON.stringify(val)); //결과값 확인 테스트용 (json값)
  //아래와 같이 json값으로 결제결과가 넘어옵니다. (* orderid 값은 db저장시 50byte의 길이로 db설정필요함)
  //val = {
  // osname:’ios’, //varchar(10) os명(android,ios)
  // title:'500캐시’, //varchar(50) 상품명
  // orderid:'2000000210350206’, //varchar(50) 주문번호
  // productid:'cont1’, //varchar(10) 상품id
  // price:'500’ //varchar(10) 결제비용
  //}
  //위 넘어온 값을 사용하여 결제완료처리 로직을 아래에 작성해주면 됩니다.
  //....
}
